import { cn } from "@/utils";

/** Popover-surface tooltips in workspace chrome (rail, tab bar, etc.). */
export const workspacePopoverTooltipContentClassName = cn(
  "rounded-lg border border-n-10 bg-popover text-n-90 shadow-elev-3",
);

/** Arrow fill when the popover arrow is shown. */
export const workspacePopoverTooltipArrowClassName = "fill-popover bg-popover";
